import { Box } from '@mui/material';
import styled from 'styled-components';

export const ContentWrapper = styled(Box)`
  display: flex;
  width: 100%;
  height: calc(100vh - 64px - 50px);
`;

export const SideBar = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  height: 100%;
  width: 100%;
  max-width: ${(props) => (props.isSideBarOpen ? '35%' : '0%')};
  transition: max-width linear 0.3s;
  background-color: var(--color-white-f5);

  @media (max-width: 768px) {
    max-width: ${(props) => (props.isSideBarOpen ? '100%' : '0%')};
  }
`;

export const SideBarOpenIconContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${(props) => (props.isSideBarOpen ? '-18px' : '-47px')};
  top: 150px;
  rotate: ${(props) => (props.isSideBarOpen ? '180deg' : '0deg')};
  cursor: pointer;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    top: 200px;
    right: ${(props) => (props.isSideBarOpen ? '5px' : '-47px')};
  }
`;

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 64px - 50px);
  z-index: 0;
  position: relative;

  @media (max-width: 768px) {
    display: ${(props) => (props.isSideBarOpen ? 'none' : 'block')};
  }
`;

export const SideBarContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  overflow: hidden;
`;

export const SideBarTitle = styled.h2`
  font: normal normal 600 1.4rem
    ${(props) => props.fontFamily ?? 'Source Sans Pro'};
  margin: 0 0 10px 0;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  color: #9e9e9e;
`;

export const SideBarCardText = styled.span`
  font: normal normal 400 1rem
    ${(props) => props.fontFamily ?? 'Source Sans Pro'};
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: black;
  padding: 10px 20px 10px 20px;
  box-sizing: border-box;
`;

export const CustomDivider = styled(Box)`
  width: 100%;
  height: 20px;
`;

export const ReturnMethodContainer = styled(Box)`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const ReturnMethodItem = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 55px;
  background-color: white;
  border: ${(props) =>
    // eslint-disable-next-line no-nested-ternary
    props.isSelected
      ? props.borderColor
        ? `2px solid ${props.borderColor}}`
        : '2px solid var(--color-blue-primary)'
      : 'none'};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 3px;
  cursor: pointer;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  overflow: hidden;
`;
